// extracted by mini-css-extract-plugin
export var attribution = "_d2-4";
export var authorName = "_d2-5";
export var quote = "_d2-3";
export var testimonial = "_d2-2";
export var trustedBy = "_d2-0";
export var trustedByLabel = "_d2-1";